<!-- Show "not supported" message if browser is IE -->
<div style="padding: 100px; text-align: center" *ngIf="this.isBrowserIE">
  <img alt="PSI logo" [src]="assets + '/psi_logo.svg'"/>
  <h1>PSI <strong>Pocket</strong> doesn't support the Internet Explorer anymore!</h1>
  <h2>Please use Firefox, Chrome or Edge <small>(Chromium-based version)</small> instead.</h2>
</div>
<ion-app *ngIf="!this.isBrowserIE">

  <ion-split-pane *ngIf="!isMobile" contentId="pocketmenu">
    <!--Sidemenu-->
    <ion-menu contentId="pocketmenu">
      <ion-header>
        <ion-toolbar>
          <!--PSI Pocket Icon-->
          <div class="pocket-icon">PSI <strong>Pocket</strong></div>
          <!--Button more-->
          <ion-button color="dark" slot="end" (click)="showSettings = !showSettings" fill="clear">
            <ion-icon slot="icon-only" name="ellipsis-vertical-outline"></ion-icon>
          </ion-button>
        </ion-toolbar>
        <ion-menu-toggle auto-hide="false">
          <div *ngIf="showSettings">
            <!--Button select profile-->
            <ion-item style="cursor:pointer" lines="none" (click)="selectProfile()">
              <ion-icon slot="start" name="repeat"></ion-icon>
              <ion-label>Change Profile</ion-label>
            </ion-item>
            <!--Button edit menu-->
            <ion-item style="cursor:pointer" lines="none" (click)="editMenu()">
              <ion-icon slot="start" name="settings"></ion-icon>
              <ion-label>Customize Profile</ion-label>
            </ion-item>
            <ion-item lines="none">
              <ion-icon slot="start" name="moon"></ion-icon>
              <ion-label>
                Toggle Dark Theme
              </ion-label>
              <ion-toggle [(ngModel)]="isDarkmode" (ionChange)="toogleDarkmode($event)" slot="end"></ion-toggle>
            </ion-item>
          </div>
        </ion-menu-toggle>
      </ion-header>

      <!--content of sidemenu-->
      <ion-content (mouseup)="closeSettingsMenu()">

        <ion-list>
          <!--COVID-19 Transport to PSI page-->
          <!--<ion-menu-toggle auto-hide="false">
            <ion-item color="corona" lines="none" routerLink="/psicheckin">
              <ion-icon slot="start" name="checkmark-done-circle"></ion-icon>
              <ion-label >
                PSI Check-in
              </ion-label>
            </ion-item>
          </ion-menu-toggle>-->
          <div *ngFor="let page of appPages">

            <!--Main page without subpages title-->
            <ion-menu-toggle *ngIf="!page.subPages" auto-hide="false">
              <ion-item lines="none" routerLink="{{page.url}}">
                <ion-icon slot="start" name="{{page.icon}}"></ion-icon>
                <ion-label>
                  {{page.title}}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>

            <!--Main page with subpages title-->
            <ion-item-group *ngIf="page.subPages">
              <ion-item lines="none" style="cursor:pointer" (click)="toggleDropdown(page.title)">
                <ion-icon slot="start" [name]="page.icon || 'stats-chart'"></ion-icon>
                <ion-label>
                  {{page.title}}
                </ion-label>
                <ion-icon *ngIf="!isDropdownOpen(page.title)" size="small" name="chevron-forward" end></ion-icon>
                <ion-icon *ngIf="isDropdownOpen(page.title)" size="small" name="chevron-down" end></ion-icon>
              </ion-item>
              <ion-menu-toggle auto-hide="false" *ngFor="let subpage of page.subPages">
                <div *ngIf="isDropdownOpen(page.title)">
                  <!--Subpage title-->
                  <ion-item lines="full" color="light" routerLink="{{subpage.url}}" *ngIf="subpage.display">
                    <ion-icon *ngIf="subpage.icon" slot="start" name="{{subpage.icon}}"></ion-icon>
                    <ion-label>
                      {{subpage.title}}
                    </ion-label>
                  </ion-item>
                </div>
              </ion-menu-toggle>
            </ion-item-group>
          </div>
        </ion-list>
      </ion-content>
      <!--footer of sidemenu-->
      <ion-footer (mouseup)="closeSettingsMenu()">
        <ion-menu-toggle auto-hide="false">
          <!--FAQ page-->
          <ion-item lines="none" routerLink="/infopage">
            <ion-icon slot="start" name="help-circle"></ion-icon>
            <ion-label>
              FAQ
            </ion-label>
          </ion-item>
        </ion-menu-toggle>
      </ion-footer>
    </ion-menu>
    <!--routing-->
    <ion-router-outlet (mouseup)="closeSettingsMenu();closeDropdownMenu()" id="pocketmenu"></ion-router-outlet>
  </ion-split-pane>

  <!-- Mobile Layout (no split pane) -->
  <ion-split-pane *ngIf="isMobile" contentId="mobile-content">
    <!--Sidemenu-->
    <ion-menu contentId="mobile-content">
      <ion-header>
        <ion-toolbar>
          <!--PSI Pocket Icon-->
          <div class="pocket-icon">PSI <strong>Pocket</strong></div>
          <!--Button more-->
          <ion-button color="dark" slot="end" (click)="showSettings = !showSettings" fill="clear">
            <ion-icon slot="icon-only" name="ellipsis-vertical-outline"></ion-icon>
          </ion-button>
        </ion-toolbar>
        <ion-menu-toggle auto-hide="false">
          <div *ngIf="showSettings">
            <!--Button select profile-->
            <ion-item style="cursor:pointer" lines="none" (click)="selectProfile()">
              <ion-icon slot="start" name="repeat"></ion-icon>
              <ion-label>Change Profile</ion-label>
            </ion-item>
            <!--Button edit menu-->
            <ion-item style="cursor:pointer" lines="none" (click)="editMenu()">
              <ion-icon slot="start" name="settings"></ion-icon>
              <ion-label>Customize Profile</ion-label>
            </ion-item>
            <ion-item lines="none">
              <ion-icon slot="start" name="moon"></ion-icon>
              <ion-label>
                Toggle Dark Theme
              </ion-label>
              <ion-toggle [(ngModel)]="isDarkmode" (ionChange)="toogleDarkmode($event)" slot="end"></ion-toggle>
            </ion-item>
          </div>
        </ion-menu-toggle>
      </ion-header>

      <!--content of sidemenu-->
      <ion-content (mouseup)="closeSettingsMenu()">
        <ion-list>
          <div *ngFor="let page of appPages">
            <!--Main page without subpages title-->
            <ion-menu-toggle *ngIf="!page.subPages" auto-hide="false">
              <ion-item lines="none" routerLink="{{page.url}}">
                <ion-icon slot="start" name="{{page.icon}}"></ion-icon>
                <ion-label>
                  {{page.title}}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>

            <!--Main page with subpages title-->
            <ion-item-group *ngIf="page.subPages">
              <ion-item lines="none" style="cursor:pointer" (click)="toggleDropdown(page.title)">
                <ion-icon slot="start" [name]="page.icon || 'stats-chart'"></ion-icon>
                <ion-label>
                  {{page.title}}
                </ion-label>
                <ion-icon *ngIf="!isDropdownOpen(page.title)" size="small" name="chevron-forward" end></ion-icon>
                <ion-icon *ngIf="isDropdownOpen(page.title)" size="small" name="chevron-down" end></ion-icon>
              </ion-item>
              <ion-menu-toggle auto-hide="false" *ngFor="let subpage of page.subPages">
                <div *ngIf="isDropdownOpen(page.title)">
                  <!--Subpage title-->
                  <ion-item lines="full" color="light" routerLink="{{subpage.url}}" *ngIf="subpage.display">
                    <ion-icon *ngIf="subpage.icon" slot="start" name="{{subpage.icon}}"></ion-icon>
                    <ion-label>
                      {{subpage.title}}
                    </ion-label>
                  </ion-item>
                </div>
              </ion-menu-toggle>
            </ion-item-group>
          </div>
        </ion-list>
      </ion-content>
      <!--footer of sidemenu-->
      <ion-footer (mouseup)="closeSettingsMenu()">
        <ion-menu-toggle auto-hide="false">
          <!--FAQ page-->
          <ion-item lines="none" routerLink="/infopage">
            <ion-icon slot="start" name="help-circle"></ion-icon>
            <ion-label>
              FAQ
            </ion-label>
          </ion-item>
        </ion-menu-toggle>
      </ion-footer>
    </ion-menu>
    <!--routing-->
    <ion-router-outlet (mouseup)="closeSettingsMenu();closeDropdownMenu()" id="mobile-content"></ion-router-outlet>
  </ion-split-pane>

  <div
    style="position: fixed; right: 12px; bottom: 12px; z-index: 1000; padding: 4px 8px; border-radius: 12px; font-size: 12px; background: rgba(0, 0, 0, 0.6); color: #fff; pointer-events: none;"
  >
    {{ versionStatus }}
  </div>
</ion-app>
